import { ApplicationInsights, ICustomProperties, IExceptionTelemetry, IPageViewTelemetry } from '@microsoft/applicationinsights-web'
class Analytics {
  appInsights: ApplicationInsights | null;
  instance = this;

  constructor() {
    this.appInsights = null;
    this.instance = this;
  }

  initializeAnalytics(appInsightsInstance: ApplicationInsights | null) {
    try {
      this.appInsights = appInsightsInstance;
    } catch (e) {
      console.error("Error initializing appInsight", e);
    }
  }

  trackPageView(queryParams: any) {
    if (!this.appInsights) {
      console.log("[Analytics] Not initialized")
      return;
    }

    if (!queryParams) {
      console.log("[Analytics] queryParams not passed")
      return;
    }

    let pageViewTelemetry: IPageViewTelemetry = {
      properties:{
        ...queryParams
      }
    }
    
    this.appInsights.trackPageView(pageViewTelemetry);
    if(process.env.NODE_ENV === "development") {
      console.log("[Analytics] trackPageView", pageViewTelemetry)
    }
  }

  trackEvent(event: string, data: any) {
    if (!this.appInsights) {
      console.log("[Analytics] Not initialized")
      return;
    }

    if (!event) {
      console.error("[Analytics] Event is required!")
      return;
    }

    if(process.env.NODE_ENV === "development") {
      console.log('[Analytics] TrackEvent', event, data);
    }

    this.appInsights.trackEvent({ name: event }, data);
  }

  // Exceptions by default don't have a type in JS
  trackException(exception: any, customProperties?: ICustomProperties) {
    if (!this.appInsights) {
      console.log("[Analytics] Not initialized")
      return;
    }

    if (!exception) {
      console.error("[Analytics] Exception is required!")
      return;
    }

    if(process.env.NODE_ENV === "development") {
      console.log('[Analytics] TrackException', exception);
    }

    // cast the exception as a telemetry exception
    const telemetryException: IExceptionTelemetry = {
      exception
    }
    this.appInsights.trackException(telemetryException, customProperties);
  }
}

export const analytics = new Analytics();
